// extracted by mini-css-extract-plugin
export default {"collect":"Collect_collect__Qzd4J"};